import { IPaymentMethod } from '../interfaces/IPaymentMethod';

export function formatPaymentMethod(
  paymentMethod: IPaymentMethod
): IPaymentMethod {
  return {
    ...(!paymentMethod?.newMethod && {
      _id: paymentMethod._id,
    }),
    name: paymentMethod.name,
    paymentType: paymentMethod.paymentType,
    picture: paymentMethod?.picture || null,
    status: paymentMethod.status,
    printReconciliationDifference: paymentMethod.printReconciliationDifference,
    requiresReconciliation: paymentMethod.requiresReconciliation,
    installments: paymentMethod.installments,
    shouldAcceptInstallments: paymentMethod.shouldAcceptInstallments,
  };
}
